import { render, staticRenderFns } from "./AssignFleet.vue?vue&type=template&id=b7858aca"
import script from "./AssignFleet.vue?vue&type=script&lang=js"
export * from "./AssignFleet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports